/**
 * 📦 V2 Operador Logístico API client
 * Rotas /api/v2/logistics-reps (vínculo Operador × produto físico)
 * Spec: docs/V2/FEATURES/OPERADOR_E_FORNECEDORES.md
 */

import v2Api from './index';

export const logisticsRepsV2API = {
  /**
   * Convida operador por email pra um produto físico.
   * Body: { physical_product_id, email, fixed_amount_cents }
   * Resposta: { mode: 'linked' | 'invited', logistics_rep? | invite? }
   */
  invite: (data) => v2Api.post('/logistics-reps/invite', data),

  /** Lista todos os operadores dos físicos de um produto. */
  listByProduct: (productId) => v2Api.get(`/logistics-reps/by-product/${productId}`),

  /** Pega o operador de um único produto físico (ou null). */
  getByPhysicalProduct: (physicalProductId) =>
    v2Api.get(`/logistics-reps/by-physical-product/${physicalProductId}`),

  /** Body: { fixed_amount_cents } */
  updateFixedAmount: (physicalProductId, data) =>
    v2Api.patch(`/logistics-reps/by-physical-product/${physicalProductId}`, data),

  remove: (physicalProductId) =>
    v2Api.delete(`/logistics-reps/by-physical-product/${physicalProductId}`),
};

export default logisticsRepsV2API;
